<template>
    <div style="height: 98%;">
        <div class="crumbs mcrumb-self">
            <el-breadcrumb separator="-">
                <el-breadcrumb-item>
                    <i class="el-icon-office-building"></i><span>系统设置</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item><span>集团管理</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- <el-divider></el-divider> -->
        <div class="container" style="padding: 15px;height: 92%;">
            <div style="display: flex;">
                <div style="width: 45%;padding-right: 10px;">
                    <span style="color: #606266;">集团公司</span>
                    <div style="padding: 10px 0px;">
                        <el-row type="flex">
                            <el-col :span="14">
                                <el-button type="primary" @click="groupOperateClickFun('0', '')">新增集团</el-button>
                                <el-button plain @click="deleteGroupDataClickFun()">删除集团</el-button>
                            </el-col>
                            <el-col :span="10" style="text-align: right;">
                                <el-input v-model="groupSearchName" placeholder="搜索所属集团名称、集团编号" prefix-icon="el-icon-search" @keyup.native="advanceQueryGroupData"/>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 94%;">
                        <el-table :data="groupTableData" border stripe height="90%" class="table" @current-change="handleSelectionChange" @row-click="chooseOne" higlight-current-row>
                            <el-table-column label="" width="55" align="center">
                                <template scope="scope">
                                    <el-radio :label="scope.row.id" v-model="groupRadio" style="margin-left: 10px;">&nbsp;</el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="id" v-if="showColumn"></el-table-column>
                            <el-table-column prop="name" label="集团名称" sortable width="200"></el-table-column>
                            <el-table-column prop="code" label="集团编号" sortable></el-table-column>
                            <el-table-column prop="state" label="状态" :formatter="formatStatus"></el-table-column>
                            <el-table-column prop="operate" label="操作" width="120" align="center" fixed="right">
                                <template slot-scope="scoped">
                                    <el-button size="small" type="text" @click="groupOperateClickFun('1', scoped.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                @size-change="handleSizeChangeGroup"
                                @current-change="handleSizeChangeGroup"
                                :current-page="groupPwm.page"
                                :page-size="groupPwm.limit"
                                :page-sizes="groupPwm.limits"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="groupPwm.count">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div style="width: 55%;padding-left: 10px;">
                    <span style="color: #606266;">对应实体</span>
                    <div style="padding: 10px 0px;">
                        <el-row type="flex">
                            <el-col :span="14">
                                <el-button type="primary" @click="companyOperateClickFun('0', '')">新增实体信息</el-button>
                                <el-button plain @click="deleteCompanyClickFun()">删除实体信息</el-button>
                            </el-col>
                            <el-col :span="10" style="text-align: right;">
                                <el-input v-model="companySearchName" placeholder="搜索实体名称、实体税号、联系人、手机号" prefix-icon="el-icon-search" @keyup.native="advanceQueryCompanyData"/>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 94%;">
                        <el-table :data="companyTableData" border stripe height="90%" class="table" @row-dblclick="viewCompanyDetail" highlight-current-row ref="companyTable" @row-click="clickRowByCheckd">
                            <el-table-column type="selection" width="55" align="center"></el-table-column>
                            <el-table-column prop="id" v-if="showColumn"></el-table-column>
                            <el-table-column prop="name" label="实体名称" sortable  width="200"></el-table-column>
                            <el-table-column prop="code" label="实体编号" sortable></el-table-column>
                            <el-table-column prop="taxNumber" label="实体税号" sortable  width="200"></el-table-column>
                            <el-table-column prop="state" label="公司状态" :formatter="this.formatStatus"></el-table-column>
                            <el-table-column prop="contact" label="联系人" sortable></el-table-column>
                            <el-table-column prop="phoneNumber" label="手机号" sortable></el-table-column>
                            <el-table-column prop="operate" label="操作" width="100" align="center" fixed="right">
                                <template slot-scope="scoped">
                                    <el-button size="small" type="text" @click="companyOperateClickFun('2', scoped.row)">查看</el-button>
                                    <el-button size="small" type="text" @click="companyOperateClickFun('1', scoped.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                @size-change="handleSizeChangeCompany"
                                @current-change="handleSizeChangeCompany"
                                :current-page="companyPwm.page"
                                :page-size="companyPwm.limit"
                                :page-sizes="companyPwm.limits"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="companyPwm.count">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 新增、编辑集团信息 -->
        <el-dialog :title="groupOpTitle" :visible.sync="groupOperateDialogVisible" width="30%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="groupForm" ref="groupForm" :rules="groupFormRule" style="width: 98%;">
                    <el-input v-if="hideId == true" v-model="groupForm.id"></el-input>
                    <div style="padding-bottom: 15px;">
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 100%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 集团名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="name">
                                        <el-input v-model="groupForm.name"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 100%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="code">
                                        <el-input v-model="groupForm.code" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 100%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>当前状态</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="state">
                                        <el-select v-model="groupForm.state" placeholder="请选择" style="width: 100%;">
                                            <el-option
                                                v-for="item in statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveGroupDataClickFun('groupForm')" style="width: 80px;">保存</el-button>
                <el-button @click="groupOperateDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>

        <!-- 新增、编辑、查看实体信息 -->
        <el-dialog :title="companyOpTitle" :visible.sync="companyOperateDialogVisible" width="55%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="companyForm" ref="companyForm" :rules="companyFormRule" style="width: 98%;">
                    <el-input v-model="companyForm.id" v-if="hideId == true"></el-input>
                    <el-input v-model="companyForm.groupId" v-if="hideId == true"></el-input>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">基本信息</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="name">
                                        <el-input v-model="companyForm.name" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 是否启用</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="state">
                                        <el-select v-model="companyForm.state" placeholder="请选择" style="width: 100%;" :disabled="disabled">
                                            <el-option
                                                v-for="item in statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="code">
                                        <el-input v-model="companyForm.code" :disabled="disabledTaxNumber"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 实体税号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="taxNumber">
                                        <el-input v-model="companyForm.taxNumber" :disabled="disabledTaxNumber"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 授权密钥</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="authKey">
                                        <el-input v-model="companyForm.authKey" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>所属集团</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupName">
                                        <el-input v-model="companyForm.companyGroup.name" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupNo">
                                        <el-input v-model="companyForm.companyGroup.code" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">详细信息</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>银行、账号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="bankAccount">
                                        <el-input v-model="companyForm.bankAccount" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>地址、电话</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="addressPhone">
                                        <el-input v-model="companyForm.addressPhone" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title">联系人</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 姓名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="contact">
                                        <el-input v-model="companyForm.contact" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 手机</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="phoneNumber">
                                        <el-input v-model="companyForm.phoneNumber" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>邮箱</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="email">
                                        <el-input v-model="companyForm.email" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>备注</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="position">
                                        <el-input v-model="companyForm.position" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveCompanyClickFun('companyForm')" style="width: 80px;" v-if="showCompanyOpBtn">保存</el-button>
                <el-button @click="companyOperateDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        data() {
            return {
                groupPwm: {
                    count: 0,
                    limit: 10,
                    page: 1,
                    limits: [10, 20, 50, 100]
                },
                companyPwm: {
                    count: 0,
                    limit: 10,
                    page: 1,
                    limits: [10, 20, 50, 100]
                },
                showColumn: false,
                hideId: false,
                groupSearchName: '',
                companySearchName: '',
                groupTableData: [],
                companyTableData: [],
                groupRadio: '',
                currentRadioSelectionItem: {},  //  当前选中行数据
                groupOpTitle: '',
                groupOperateDialogVisible: false,
                groupOpUrl: '',    //  操作类型 url
                groupForm: {
                    name: '',
                    code: '',
                    state: '0'
                },
                groupFormRule: {
                    name: [
                        { required: true, message: '请输入集团名称', trigger: 'blur'},
                        { max: 20, message: '集团名称不得超过20个字符'}
                    ],
                    code: [
                        { required: true, message: '请输入集团编号', trigger: 'blur'},
                        { max: 20, message: '集团编号不得超过20个字符'}
                    ]
                },
                companyOpTitle: '',
                companyOperateDialogVisible: false,
                showCompanyOpBtn: true,
                companyOpUrl: '',
                companyForm: {
                    groupId: '',
                    name: '',
                    state: '0',
                    code: '',
                    taxNumber: '',
                    authKey: '',
                    bankAccount: '',
                    addressPhone: '',
                    contact: '',
                    phoneNumber: '',
                    email: '',
                    position: '',
                    companyGroup: {}
                },
                companyFormRule: {
                    name: [
                        { required: true, message: '请输入实体名称', trigger: 'blur'},
                        { max: 20, message: '实体名称不得超过20个字符'}
                    ],
                    code: [
                        { required: true, message: '请输入实体编号', trigger: 'blur'},
                        { max: 10, message: '实体编号不得超过10个字符'}
                    ],
                    taxNumber: [
                        { required: true, message: '请输入实体税号', trigger: 'blur'},
                        { min: 15, max: 18, message: '实体税号不得超过15~18个字符'}
                    ],
                    authKey: [
                        { required: true, message: '请输入授权密钥', trigger: 'blur'}
                    ],
                    bankAccount: [
                        { required: false, max: 50, message: '银行、账号不得超过50个字符'}
                    ],
                    addressPhone: [
                        { required: false, max: 50, message: '地址、电话不得超过50个字符'}
                    ],
                    contact: [
                        { required: true, message: '请输入联系人姓名', trigger: 'blur'},
                        { max: 10, message: '联系人姓名不得超过10个字符'}
                    ],
                    phoneNumber: [
                        { required: true, message: '请输入联系人手机号', trigger: 'blur'},
                        { validator: this.checkMobile }
                    ],
                    email: [
                        { max: 40, message: '联系人邮箱长度不得超过40个字符' },
                        { validator: this.checkEmail }
                    ]
                },
                disabled: false,    //  字段是否禁用
                disabledTaxNumber: false,   //  实体税号是否禁用
            }
        },
        created: function() {
            this.getGroupTableData();
        },
        mounted: function() {
            
        },
        methods: {
            handleSizeChangeGroup(val) {
                this.groupPwm.limit = val;
                this.getGroupTableData();
            },
            handleCurrentChangGroup(val) {
                this.groupPwm.page = val;
                this.getGroupTableData();
            },
            handleSizeChangeCompany(val) {
                this.companyPwm.limit = val;
                this.getCompanyTableData(this.currentRadioSelectionItem.id);
            },
            handleCurrentChangCompany(val) {
                this.companyPwm.page = val;
                this.getCompanyTableData(this.currentRadioSelectionItem.id);
            },
            getGroupTableData: function() {   //  load group table data
                this.groupPwm.limit = 10;
                this.groupPwm.page = 1;
                let pwm = this.groupPwm;
                pwm.likeSearch = this.groupSearchName;
                fetchPost('/sys/admin/getCompanyGroupList', pwm).then(res => {
                    this.groupTableData = res.data.data;
                    this.groupPwm.count = res.data.count;

                    if(res.data.data && res.data.data.length > 0) {
                        this.groupRadio = res.data.data[0].id;
                        this.currentRadioSelectionItem = res.data.data[0];
                        this.getCompanyTableData(res.data.data[0].id);
                    }
                }, error => {
                    this.$message.error('加载集团信息失败：' + error);
                }).catch(error => {
                    this.$message.error('加载集团信息失败：' + error);
                });
            },
            getCompanyTableData(groupId) {  //  load company table data
                this.companyPwm.page = 1;
                this.companyPwm.limit = 10;
                let pwm = this.companyPwm;
                pwm.search = {'groupId': groupId};
                pwm.likeSearch = this.companySearchName;
                fetchPost('/sys/admin/getCompanyList', pwm).then(res => {
                    this.companyTableData = res.data.data;
                    this.companyPwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载实体信息失败：' + error);
                }).catch(error => {
                    this.$message.error('加载实体信息失败：' + error);
                });
            },
            getCompanyById(rowData) {   //  查看详情
                fetchPost('/sys/admin/getCompanyById', rowData.id).then(res => {
                    if(res.data.success) {
                        this.companyForm = res.data.obj;
                        this.companyOperateDialogVisible = true;
                    } else {
                        this.$message.error('加载实体信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载实体信息失败：' + error);
                });
            }, 
            advanceQueryGroupData() {   //  group 模糊查询
                this.getGroupTableData();
            },
            advanceQueryCompanyData() { //  company 模糊查询
                this.getCompanyTableData(this.currentRadioSelectionItem.id);
            },
            chooseOne(row) {    //  group table radio点击行即选中单选行t
                this.groupRadio = row.id;
                this.getCompanyTableData(row.id);
            },
            handleSelectionChange(row) {    //  group table 点击行切换实体信息
                this.currentRadioSelectionItem = row;
            },
            clickRowByCheckd(row) {    //  company table点击行即选中该行
                this.$refs.companyTable.toggleRowSelection(row);
            },
            groupOperateClickFun(opType, rowData) {
                Object.keys(this.groupForm).map(key => (this.groupForm[key] = '')); //  重置表单
                this.$nextTick(() => {
                    if(this.$refs.groupForm) {
                        this.$refs.groupForm.clearValidate();   //  重置表单校验
                    }
                });
                if(opType == '0') {
                    this.disabled = false;
                    this.groupOpTitle = '集团信息新增';
                    this.groupOpUrl = '/sys/admin/addCompanyGroup';
                    this.groupForm.state = '0';
                } else if(opType == '1') {
                    this.disabled = true;
                    this.groupOpTitle = '集团信息编辑';
                    this.groupOpUrl = '/sys/admin/updateCompanyGroup';
                    this.groupForm = JSON.parse(JSON.stringify(rowData));
                }
                this.groupOperateDialogVisible = true;
            },
            saveGroupDataClickFun(formName) {   //  save / update group data
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let groupData = this.groupForm;
                    fetchPost(this.groupOpUrl, groupData).then(res => {
                        let result = res.data;
                        if(result.success) {
                            this.$message.success('保存集团成功！');
                            //  close dialog
                            this.groupOperateDialogVisible = false;
                            //  reload group table
                            this.getGroupTableData();
                            //  reset form 
                            // this.$refs.groupForm.resetFields();
                        } else {
                            this.$message.error('保存集团数据失败：' + result.message);
                        }
                    }, error => {
                        this.$message.error('保存集团数据失败：' + error);
                    });
                });
            },
            deleteGroupDataClickFun() { //  删除
                let checkRow = this.currentRadioSelectionItem;
                 if(!this.groupRadio) {
                    this.$message.warning('请选择需要删除的集团信息！');
                    return;
                }
                let companyData = this.getCompanyTableData(checkRow.id);
                if(companyData && companyData.length != 0) {
                    this.$message.error('当前集团下有实体信息，无法删除！' );
                    return;
                }
                this.$confirm('是否确认删除当前集团？', '提示', { type: 'warning' }).then(data => {
                    let ids = checkRow.id;
                    fetchPost('/sys/admin/deleteCompanyGroups', ids).then(res => {
                        let result = res.data;
                        if(result.success) {
                            this.$message.success('删除集团信息成功！');
                            this.groupOperateDialogVisible = false;
                            //  reload group table
                            this.getGroupTableData();;
                        } else {
                            this.$message.error('删除集团信息失败：' + result.message);
                        }
                    }, error => {
                        this.$message.error('删除集团信息失败：' + error);
                    });
                });
            },
            companyOperateClickFun(opType, rowData) {
                Object.keys(this.companyForm).map(key => (this.companyForm[key] = ''));
                this.$nextTick(() => {
                    if(this.$refs.companyForm) {
                        this.$refs.companyForm.clearValidate();
                    }
                });
                if(opType == '0') {
                    this.companyOpTitle = '实体信息新增';
                    this.showCompanyOpBtn = true;
                    this.disabled = false;
                    this.disabledTaxNumber = false;
                    if(!this.groupRadio || this.groupRadio == null) {
                        this.$message.warning('请选择需要新增实体的所属集团信息！');
                        return;
                    }
                    this.companyForm.state = '0';
                    this.companyForm.companyGroup = {
                        name: this.currentRadioSelectionItem.name,
                        code: this.currentRadioSelectionItem.code
                    }
                    this.companyOpUrl = '/sys/admin/addCompany';

                    this.companyOperateDialogVisible = true;
                } else if(opType == '1') {
                    this.companyOpTitle = '实体信息编辑';
                    this.showCompanyOpBtn = true;
                    this.disabled = false;
                    this.disabledTaxNumber = true;

                    this.getCompanyById(rowData);
                    this.companyOpUrl = '/sys/admin/updateCompany';
                } else if(opType == '2') {
                    this.companyOpTitle = '实体信息详情'; 
                    this.showCompanyOpBtn = false;
                    this.disabled = true;
                    this.disabledTaxNumber = true;

                    this.getCompanyById(rowData);
                }
            },
            viewCompanyDetail(row, column, event) {
                this.companyOperateClickFun('2', row);
            },
            saveCompanyClickFun(formName) { //  保存实体信息
                 this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let companyData = this.companyForm;
                    companyData.groupId = this.currentRadioSelectionItem.id;
                    fetchPost(this.companyOpUrl, companyData).then(res => {
                        let result = res.data;
                        if(result.success) {
                            this.$message.success('保存实体信息成功！');
                            this.companyOperateDialogVisible = false;
                            //  reload company table
                            this.getCompanyTableData(companyData.groupId);
                        } else {
                            this.$message.error('保存实体信息失败：' + result.message);
                        }
                    }, error => {
                        this.$message.error('保存实体信息失败：' + error);
                    });
                });
            },
            deleteCompanyClickFun() {   //  删除实体信息
                let idList = [];
                let checkRows = this.$refs.companyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除的实体信息！');
                    return;
                }
                checkRows.forEach(row => {
                    idList.push(row.id);
                });
                this.$confirm('是否删除当前选中实体信息？', '提示', { type: 'warning' }).then(data => {
                    let ids = idList.join(',');
                    fetchPost('/sys/admin/deleteCompanys', ids).then(res => {
                        let result = res.data;
                        if(result.success) {
                            this.$message.success('删除实体公司信息成功！');
                            this.companyOperateDialogVisible = false;
                            //  reload company table
                            this.getCompanyTableData(this.currentRadioSelectionItem.id);
                        } else {
                            this.$message.error('删除实体公司信息失败：' + result.message);
                        }
                    }, error => {
                        this.$message.error('删除实体公司信息失败：' + error);
                    });
                });
            },
        }
    }   
</script>

<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
</style>